import { render } from "./contentDescription.vue?vue&type=template&id=bf5b3288"
import script from "./contentDescription.vue?vue&type=script&lang=js"
export * from "./contentDescription.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__